// hooks
import React, { useEffect } from "react";
import { useForm, Controller } from "react-hook-form";
import { useMutation, useQuery } from "react-query";

// conponents
import { InputText } from "primereact/inputtext";
import { Toolbar } from "primereact/toolbar";
import { Button } from "primereact/button";
import { Link, useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { InputSwitch } from "primereact/inputswitch";
import JoditEditor from "jodit-react";
import { InputTextarea } from "primereact/inputtextarea";

// utils
import Api from "../../api/Api";

// api related
import basicJodithConfig from "../../config/basicJodithConfig";
import MultiSelectImagesCRUD from "../../components/MultiSelectImagesCRUD";

const LifeOnBoardUpdate = () => {
  let type = 4;
  let navigate_route = "/dashboard/life-on-board";
  let name = "Life on Board";
  const { id } = useParams();
  const navigate = useNavigate();

  // hooks
  const { control, handleSubmit, reset, formState } = useForm();

  // query
  const { data: imagesOption, isLoading: loadingImageOption, refetch } = useQuery(["content-image", type], () => getImageOptions());
  const { isLoading: createLoading, mutate: crateMutate } = useMutation(async (data) => await Api().post("/content/edit", data), {
    onSettled: async (response, error) => {
      try {
        if (response.data.status !== 200) {
          throw new Error(response.data.message);
        }
        navigate(navigate_route);
        toast.success(name + " updated!");
      } catch (error) {
        toast.error(error.message || "Something went wrong , try again later", { duration: 5000 });
      }
    },
  });

  // functions
  const getImageOptions = async () => {
    try {
      const res = await Api().get(`/content-image?type=${type}&limit=100`);

      if (res.data.status !== 200) {
        throw new Error(res.data.message);
      }

      return res.data.data;
    } catch (error) {
      toast.error(error.message);
      return error;
    }
  };
  const getProductDetails = async () => {
    try {
      const res = await Api().get("/content/detail/" + id);

      if (res.data.status !== 200) {
        throw new Error(res.data.message);
      }

      // mapping
      let result = res.data.data;
      result.thumbnail_images = result.thumbnail_images.map((data) => data._id);
      result.banner = result.banner.map((data) => data._id);
      result.images = result.images.map((data) => data._id);
      result.related = result.related.map((data) => data._id);
      result.related2 = result.related2.map((data) => data._id);

      for (let i = 0; i < result.body.length; i++) {
        const only_get_image_id = result.body[i].images.map((img) => img._id);
        result.body[i].images = only_get_image_id;
      }

      reset(result);
      return result;
    } catch (error) {
      toast.error(error.message);
      return error;
    }
  };

  const onSubmit = (data) => {
    data.content_id = id;
    data.type = type;
    crateMutate(data);
  };

  // components
  const leftToolbar = () => {
    return (
      <React.Fragment>
        <div className="my-2">
          <h4 className="uppercase" style={{ margin: 0 }}>
            Update {name}
          </h4>
        </div>
      </React.Fragment>
    );
  };

  useEffect(() => {
    getProductDetails();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <form onSubmit={handleSubmit(onSubmit)} style={{ borderRadius: "0px" }} className="card grid col-12 mx-auto">
      <div className="col-12">
        <Toolbar className="mb-4 w-full" left={leftToolbar} />
      </div>

      {/* meta */}
      <div className="col-12">
        <p className="font-bold uppercase">Meta Section</p>
      </div>
      <div className="field col-12">
        <label htmlFor="title">Meta Title : </label>
        <div className="w-full">
          <Controller control={control} defaultValue={""} name="meta_title" render={({ field }) => <InputText placeholder="Input meta title" value={field.value} onBlur={field.onBlur} ref={field.ref} onChange={(e) => field.onChange(e)} id="name" type="text" className="w-full" />} />
        </div>
      </div>
      <div className="field col-12">
        <label htmlFor="title">Meta Description : </label>
        <div className="w-full">
          <Controller
            control={control}
            defaultValue={""}
            name="meta_description"
            render={({ field }) => <InputTextarea value={field.value} onBlur={field.onBlur} ref={field.ref} onChange={(e) => field.onChange(e)} className="w-full" placeholder="input meta description" autoResize rows="3" cols="20" />}
          />
        </div>
      </div>

      {/* content */}
      <div className="col-12">
        <p className="font-bold uppercase">Content Section</p>
      </div>
      <div className="field col-12">
        <label htmlFor="thumbnail_images">Thumbnail Images : </label>
        <div className="w-full">
          <Controller
            control={control}
            defaultValue={[]}
            name="thumbnail_images"
            rules={{ required: true }}
            render={({ field }) => (
              <MultiSelectImagesCRUD
                name={name}
                onChange={field.onChange}
                isInvalid={formState?.errors?.thumbnail_images}
                isLoading={loadingImageOption}
                options={imagesOption}
                type={type}
                onSuccess={refetch}
                createEndpoint="/content-image"
                updateEndpoint="/content-image/edit"
                deleteEnpoint="/content-image"
                idKey="content_image_id"
                value={field.value}
              />
            )}
          />
          {formState?.errors?.thumbnail_images && (
            <small id="name" className="p-error block pt-1">
              Field Required
            </small>
          )}
        </div>
      </div>
      <div className="field col-12">
        <label htmlFor="banner">Banner Images : </label>
        <div className="w-full">
          <Controller
            control={control}
            name="banner"
            defaultValue={[]}
            render={({ field }) => (
              <MultiSelectImagesCRUD
                name={name}
                onChange={field.onChange}
                isInvalid={formState?.errors?.banner}
                isLoading={loadingImageOption}
                options={imagesOption}
                type={type}
                onSuccess={refetch}
                createEndpoint="/content-image"
                updateEndpoint="/content-image/edit"
                deleteEnpoint="/content-image"
                idKey="content_image_id"
                value={field.value}
              />
            )}
          />
        </div>
      </div>
      <div className="field col-12">
        <label htmlFor="title">Title : </label>
        <div className="w-full">
          <Controller control={control} defaultValue={""} name="title" render={({ field }) => <InputText placeholder="Input title" value={field.value} onBlur={field.onBlur} ref={field.ref} onChange={(e) => field.onChange(e)} id="name" type="text" className="w-full" />} />
        </div>
      </div>

      <div className="field col-12">
        <label htmlFor="title">Description : </label>
        <div className="w-full">
          <Controller
            control={control}
            name="description"
            render={({ field }) => (
              <JoditEditor
                ref={field.ref}
                value={field.value || ""}
                config={basicJodithConfig}
                tabIndex={1}
                onBlur={(e) => {
                  field.onBlur(e);
                }}
                onChange={(e) => {
                  field.onChange(e);
                }}
              />
            )}
          />
        </div>
      </div>
      <div className="field col-12">
        <label htmlFor="images">Images : </label>
        <div className="w-full">
          <Controller
            control={control}
            name="images"
            defaultValue={[]}
            render={({ field }) => (
              <MultiSelectImagesCRUD
                name={name}
                onChange={field.onChange}
                isInvalid={formState?.errors?.images}
                isLoading={loadingImageOption}
                options={imagesOption}
                type={type}
                onSuccess={refetch}
                createEndpoint="/content-image"
                updateEndpoint="/content-image/edit"
                deleteEnpoint="/content-image"
                idKey="content_image_id"
                value={field.value}
              />
            )}
          />
        </div>
      </div>
      <div className="field col-12">
        <label htmlFor="active_status">Active Status : </label>
        <div className="w-full">
          <Controller control={control} defaultValue={false} name="active_status" render={({ field }) => <InputSwitch onChange={(e) => field.onChange(e)} checked={field.value} />} />
        </div>
      </div>
      <div className="flex justify-content-center mt-4 w-full">
        <Button label="Save" loading={createLoading} className=" p-button-primary mr-4" />
        <Link to={navigate_route}>
          <Button type="button" label="Back" className=" p-button-secondary" />
        </Link>
      </div>
    </form>
  );
};

const comparisonFn = function (prevProps, nextProps) {
  return prevProps.location?.path === nextProps.location?.path;
};

export default React.memo(LifeOnBoardUpdate, comparisonFn);
